// extracted by mini-css-extract-plugin
export default {"options_parent":"SearchBar_options_parent__IPu1l","options_box":"SearchBar_options_box__tEaLf"};